module.exports = __webpack_public_path__ + "img/emoji_26.3a33a35c.png";